module.exports = __webpack_public_path__ + "static/img/H29.2094d73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H29.png
// module id = rUDW
// module chunks = 0